import { FormControl } from "@mui/material";
import FiltrosRedux from "contexts/Filtros";
import { AnimatePresence } from "framer-motion";
import {
	useCallback,
	useContext,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import Select from "react-select";
import CloseIcon from "../../../../components/CloseIcon/CloseIcon";
import CustomButtonV2 from "../../../../components/CustomButtonV2/CustomButtonV2.js";
import FiltroV2 from "../../../../components/FiltroV2/FiltroV2";
import HeaderCadastro from "../../../../components/HeaderCadastro/HeaderCadastro";
import ModalConfirmacao from "../../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalConfirmacao2 from "../../../../components/ModalConfirmacao2/ModalConfirmacao2.tsx";
import ModalUsuario from "../../../../components/ModalUsuario/ModalUsuario.tsx";
import { TabelaVirtualizadaGenerica } from "../../../../components/TabelaVirtualizadaGenerica/TabelaVirtualizadaGenerica.tsx";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import { colunasEmpresaInicial } from "../../../../contexts/ContextConstants.ts";
import MultiplosFiltrosRedux from "../../../../contexts/MultiplosFiltros.js";
import { useProfile } from "../../../../contexts/ProfileContext.tsx";
import RequestControllerRedux from "../../../../contexts/RequestController";
import TabelaRedux from "../../../../contexts/Tabela";
import { useToast } from "../../../../contexts/ToastContext.tsx";
import MotionContainer from "../../../../core/components/MotionContainer.tsx";
import MotionSemAutorizacao from "../../../../core/components/MotionSemAutorizacao.tsx";
import Separator from "../../../../core/components/Separator.tsx";
import InputError from "../../../../core/data-display/InputErrors.tsx";
import Layout from "../../../../core/layout/Layout.tsx";
import {
	renavamValido,
	verificaPlacaValida,
} from "../../../../core/utils/validators.ts";
import { useRowClick } from "../../../../hooks/useRowClick.ts";
import { CaminhaoModel } from "../../../../models/Caminhao";
import { valorMask } from "../../../../regex/valorMask";
import {
	cadastraCaminhao,
	deleteCaminhaoPorId,
	editaCaminhaoPorId,
	getCaminhao,
	getCaminhaoPorId,
	transformaMercosulCaminhao,
} from "../../../../services/ModuloGerenciador/Caminhao";
import { getCaminhaoSearch } from "../../../../services/ModuloGerenciador/Search";
import { VerificaExistenciaCaminhao } from "../../../../services/ModuloGerenciador/VerificaExistencia";
import "./Caminhao.css";

const itensFiltro = [
	{
		nomeColuna: "Placa",
		field: "placa",
	},
	{
		nomeColuna: "Ano",
		field: "ano",
	},
	{
		nomeColuna: "Renavam",
		field: "renavam",
	},
	{
		nomeColuna: "Marca",
		field: "marca",
	},
	{
		nomeColuna: "Modelo",
		field: "modelo",
	},
	{
		nomeColuna: "KM",
		field: "km",
	},
	{
		nomeColuna: "Frota",
		field: "frota",
	},
];

const labelFrota = (data) => <div>{data.opcao}</div>;

function Caminhao(props) {
	const { profile, hasRegra, tabelaEmpresa } = useProfile();

	const { setFiltrosRedux } = useContext(FiltrosRedux);

	const { showToast } = useToast();

	const [valuesPesquisa, setValuesPesquisa] = useState([]);

	const hasBuscadoCaminhao = useRef(false);

	const { multiplosFiltrosRedux } = useContext(MultiplosFiltrosRedux);

	const buscarSearch = useCallback(async () => {
		setLoading(true);
		let pesquisaFormatada = `${valuesPesquisa.item}=${valuesPesquisa.pesquisa}`;
		if (multiplosFiltrosRedux && multiplosFiltrosRedux.length) {
			for (let filtro of multiplosFiltrosRedux) {
				pesquisaFormatada += `&${filtro.field}=${filtro.valor}`;
			}
		}
		await getCaminhaoSearch(profile?.token, pesquisaFormatada)
			.then((result) => {
				setDadosTabela(result.data);
				setLoading(false);
			})
			.catch((error) => {
				if (error.response?.data?.length > 200) {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
				} else {
					setTextoErro(error.response.data);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	}, [profile?.token, valuesPesquisa, multiplosFiltrosRedux]);

	const { setDadosRequestControllerRedux } = useContext(RequestControllerRedux);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const [dadosTabela, setDadosTabela] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [editando, setEditando] = useState(false);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState(new CaminhaoModel({}));

	const [valuesSelect, setValuesSelect] = useState([]);

	const [validator, setValidator] = useState({
		placa: "true",
		renavam: "true",
		ano: "true",
		numeroEixos: "true",
	});

	const [open, setOpen] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const [errorMessagePlacaValida, setErrorMessagePlacaValida] = useState("");

	const [errorAnoValido, setErrorAnoValido] = useState("");

	const [openMercosul, setOpenMercosul] = useState(false);

	const handleCloseMercosul = (value) => {
		setOpenMercosul(false);
	};

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const [openUsuario, setOpenUsuario] = useState(false);

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const handleSingleClick = useCallback(
		(row) => {
			if (!row) return;
			setTabelaRedux({
				colunaSelecionada: row.idCaminhao,
				usuarioAlteracao: row.usuario || row.usuarioAlteracao || null,
				dataAlteracao: row.data || row.dataAlteracao || null,
				row,
			});
		},
		[setTabelaRedux]
	);

	const handleDoubleClick = useCallback(() => {
		setTelaCadastro(true);
		setEditando(true);
	}, []);

	const handleRowClick = useRowClick({
		idKey: "idCaminhao",
		onSelect: handleSingleClick,
		onDouble: handleDoubleClick,
	});

	const getRowClassName = useCallback(
		(row) => {
			if (!tabelaRedux?.colunaSelecionada) return "";
			return row.idCaminhao === tabelaRedux.colunaSelecionada
				? "selecionado"
				: "";
		},
		[tabelaRedux?.colunaSelecionada]
	);

	const buscarCaminhao = useCallback(async () => {
		setLoading(true);
		setValuesPesquisa([]);
		await getCaminhao(profile?.token).then((result) => {
			setDadosTabela(result.data);
		});
		setLoading(false);
	}, [profile?.token, setTabelaRedux]);

	const verificadorExistenciaCaminhao = async (placaCaminhao) => {
		if (!!placaCaminhao) {
			const placaCaminhaoValida = verificaPlacaValida(placaCaminhao);

			if (!placaCaminhaoValida) {
				setTextoErro("Placa do caminhão inválida.");
				setErrorMessagePlacaValida("Placa do caminhão inválida.");
				setValidator((current) => ({ ...current, placa: "false" }));
				setOpenToastErro(true);
				return;
			}

			await VerificaExistenciaCaminhao(profile?.token, placaCaminhao)
				.then((result) => {
					if (result.data === true) {
						setTextoSucesso("Placa do caminhão não possui nenhum vínculo.");
						setValidator((current) => ({ ...current, placa: "true" }));
						setOpenToastSucesso(true);
					} else {
						setTextoErro(
							"Placa do caminhão já possui um vínculo ativo, não será possível cadastrar novamente com ela."
						);
						setValidator((current) => ({ ...current, placa: "false" }));
						setOpenToastErro(true);
					}
				})
				.catch(() => {
					setTextoErro(
						"Placa do caminhão já possui um vínculo ativo, não será possível cadastrar novamente com ela."
					);
					setOpenToastErro(true);
				});
		}
	};

	const cadastrar = async () => {
		setOpenToastErro(false);
		setOpenToastSucesso(false);
		if (!verificaPlacaValida(values.placa)) {
			showToast("Placa do caminhão inválida.", "error");
			setValidator((current) => ({
				...current,
				placa: "false",
			}));
			setErrorMessagePlacaValida("Placa do caminhão inválida.");
			return;
		}
		if (!renavamValido(values.renavam)) {
			showToast("RENAVAM inválido.", "error");
			setValidator((current) => ({ ...current, renavam: "false" }));
			return;
		}
		if (!values.numeroEixos) {
			showToast("Número de eixos é obrigatório.", "error");
			setValidator((current) => ({
				...current,
				numeroEixos: "false",
			}));
			return;
		}
		if (isAnoFuturo) {
			showToast("Ano não pode ser no futuro.", "error");
			setErrorAnoValido("Ano não pode ser no futuro.");
			setValidator((current) => ({ ...current, ano: "false" }));
			return;
		}

		setLoading(true);
		if (values.frota === "Sim") values.frota = true;
		if (values.frota === "Não") values.frota = false;
		if (values.placa && validator.placa === "true") {
			await cadastraCaminhao(values, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						setValues({});
						setTelaCadastro(false);
						if (!valuesPesquisa.pesquisa) {
							buscarCaminhao();
						} else {
							buscarSearch();
						}
						setDadosRequestControllerRedux("Fechar Modal Caminhao");
						setTabelaRedux({});
						showToast("Caminhão cadastrada com sucesso!", "success");
						setValues({});
					}
				})
				.catch((error) => {
					setValues(values);
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
						if (error.response.data === "Ano deve ter 4 caracteres.") {
							setErrorAnoValido("Ano deve ter 4 caracteres.");
							setValidator((current) => ({ ...current, ano: "false" }));
						}
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
				});
		} else {
			setTextoErro("Há campos sem preencher!");
			setOpenToastErro(true);
		}
		setLoading(false);
	};

	const editar = async () => {
		setOpenToastErro(false);
		setOpenToastSucesso(false);
		if (!verificaPlacaValida(values.placa)) {
			setErrorMessagePlacaValida("Placa do caminhão inválida.");
			showToast("Placa do caminhão inválida.", "error");
			setValidator((current) => ({
				...current,
				placa: "false",
			}));
			return;
		}
		if (!renavamValido(values.renavam)) {
			showToast("RENAVAM inválido.", "error");
			setValidator((current) => ({ ...current, renavam: "false" }));
			return;
		}
		if (!values.numeroEixos) {
			showToast("Número de eixos é obrigatório.", "error");
			setValidator((current) => ({
				...current,
				numeroEixos: "false",
			}));
			return;
		}
		if (isAnoFuturo) {
			showToast("Ano não pode ser no futuro.", "error");
			setErrorAnoValido("Ano não pode ser no futuro.");
			setValidator((current) => ({ ...current, ano: "false" }));
			return;
		}

		setLoading(true);
		if (values.frota === "Sim") values.frota = true;
		if (values.frota === "Não") values.frota = false;
		await editaCaminhaoPorId(values, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					if (valuesPesquisa.pesquisa === undefined) {
						buscarCaminhao();
					} else {
						buscarSearch();
					}
					setTabelaRedux({});
					showToast("Caminhão editado com sucesso!", "success");
					setTelaCadastro(false);
					setEditando(false);
					setValues({});
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					if (error.response.data === "Ano deve ter 4 caracteres.") {
						setErrorAnoValido("Ano deve ter 4 caracteres.");
						setValidator((current) => ({ ...current, ano: "false" }));
					}
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
				}
			});
		setLoading(false);
	};

	const title = useMemo(() => {
		if (editando) return "Detalhes de Caminhão";
		if (telaCadastro) return "Cadastro de Caminhão";
		return "Caminhões";
	}, [editando, telaCadastro]);

	const isAnoFuturo = useMemo(() => {
		const anoAtual = new Date().getFullYear();
		const anoCarreta = parseInt(values.ano, 10);
		return !isNaN(anoCarreta) && anoCarreta > anoAtual;
	}, [values.ano]);

	const buscarCaminhaoPorId = async () => {
		setLoading(true);
		await getCaminhaoPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					if (editando) {
						preencherDadosEditando(result.data);
						setValues(result.data);
						setLoading(false);
					}
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const transformaMercosul = async () => {
		setLoading(true);
		await transformaMercosulCaminhao(
			tabelaRedux.colunaSelecionada,
			profile?.token
		)
			.then((result) => {
				if (result.status === 200) {
					buscarCaminhao();
					setTextoSucesso("Placa alterada Com Sucesso");
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarCaminhaoPorIdModal = async (id) => {
		setLoading(true);
		await getCaminhaoPorId(id, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					setValues(result.data);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const deletarCaminhaoPorId = async () => {
		setLoading(true);
		await deleteCaminhaoPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					buscarCaminhao();
					setTabelaRedux({});
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	useEffect(() => {
		if (profile?.usuario) {
			setValues((current) => ({
				...current,
				usuario: profile?.usuario.usuario,
			}));
		}
	}, [telaCadastro, profile?.usuario]);

	useEffect(() => {
		if (editando && tabelaRedux.colunaSelecionada) {
			buscarCaminhaoPorId();
		}
	}, [editando, tabelaRedux.colunaSelecionada]);

	useEffect(() => {
		if (props.idAtual) {
			buscarCaminhaoPorIdModal(props.idAtual);
		}
	}, [props.idAtual]);

	useEffect(() => {
		if (props.telaCadastro) {
			setTelaCadastro(true);
		}
	}, [props.telaCadastro]);

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	useEffect(() => {
		if (profile?.token && !hasBuscadoCaminhao.current) {
			setSemAutorizacao(!hasRegra("Veiculo"));
			buscarCaminhao();
			hasBuscadoCaminhao.current = true;
		}
	}, [profile?.token, hasRegra, buscarCaminhao]);

	useEffect(() => {}, [setFiltrosRedux]);

	const opcoesFrota = useMemo(() => {
		return colunasEmpresaInicial.Opcoes.map((data) => ({
			value: data.opcao,
			label: data.opcao,
			...data,
		}));
	}, []);

	const estiloFrota = {
		control: (provided) => ({
			...provided,
			minHeight: "30px",
			borderRadius: "7px",
			border: "1px solid var(--Background-Input, #F2F2F2)",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided) => ({
			...provided,
			width: "max-content",
			minWidth: props.classeCss ? props.classeCss : "250px",
			zIndex: 1401,
		}),
		menuPortal: (provided) => ({
			...provided,
			zIndex: 1401,
		}),
		singleValue: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
		option: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
	};

	const preencherDadosEditando = async (result) => {
		let frota;
		if (result.frota === true) {
			frota = "Sim";
		} else {
			frota = "Não";
		}
		const frotaSelecionado = opcoesFrota.find(
			(option) => option.value === frota
		);
		if (frotaSelecionado) {
			setValuesSelect((current) => ({ ...current, frota: frotaSelecionado }));
		}
	};

	const handleChangePlaca = useCallback((e) => {
		setValues((current) => ({
			...current,
			placa: e.target.value.toUpperCase(),
		}));
		setValidator((current) => ({
			...current,
			placa: "true",
		}));
	}, []);

	const handleChangeRenavam = useCallback((e) => {
		setValues((current) => ({
			...current,
			renavam: valorMask(e.target.value),
		}));
		setValidator((current) => ({
			...current,
			renavam: "true",
		}));
	}, []);

	const limpar = useCallback(() => {
		setValuesPesquisa([]);
		buscarCaminhao();
	}, [buscarCaminhao]);

	useEffect(() => {
		if (telaCadastro && !editando) {
			setValues((current) => ({
				...current,
				frota: "Não",
			}));
			const frotaSelecionado = opcoesFrota.find(
				(option) => option.value === "Não"
			);
			if (frotaSelecionado) {
				setValuesSelect((current) => ({ ...current, frota: frotaSelecionado }));
			}
		}
	}, [telaCadastro, editando, opcoesFrota]);

	useEffect(() => {
		setOpenToastErro(false);
		setValidator((current) => ({
			...current,
			placa: "true",
			renavam: "true",
			ano: "true",
			numeroEixos: "true",
		}));
	}, [telaCadastro, editando]);

	const isLoading = useMemo(() => {
		return (
			loading ||
			!profile?.token ||
			(!dadosTabela.length && !hasBuscadoCaminhao.current)
		);
	}, [loading, dadosTabela.length, profile?.token]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<Layout title={title} showNavbar={props.navbar}>
			<AnimatePresence mode="wait">
				{!telaCadastro ? (
					<MotionContainer animationKey="CaminhaoScreen">
						<div className="content-container">
							<div>
								<Separator size="md" />
								<FiltroV2
									classe="div-filtrar-embarque-v2"
									classOption="select-options-cliente"
									itensFiltro={itensFiltro}
									valuesPesquisa={valuesPesquisa}
									setValuesPesquisa={setValuesPesquisa}
									buscarSearch={buscarSearch}
									limpar={limpar}
								/>
								<Separator size="md" />
							</div>
							<TabelaVirtualizadaGenerica
								dados={dadosTabela}
								colunas={tabelaEmpresa.Caminhao}
								rowHeight={20}
								isLoading={isLoading}
								getRowClassName={getRowClassName}
								onRowClick={handleRowClick}
							/>
						</div>
						<div className="footer-space-between">
							<div>
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Cadastrar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setTelaCadastro(true);
										setEditando(false);
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-editar"
									classText="button-texto-editar"
									titulo="Editar"
									icone="iconeEdit"
									cor="#CDCDCD"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setTelaCadastro(true);
											setEditando(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-deletar"
									classText="button-texto-cadastrar"
									titulo="Deletar"
									icone="iconeDelete"
									cor="#DC2D2D"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setOpen(true);
											setTextoSucesso("Deletado Com Sucesso");
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
							<div>
								<CustomButtonV2
									classCss="custom-button-user"
									classText="button-texto-user"
									titulo="Obter Usuário"
									cor="#FFFFFF"
									valor={values}
									onClick={() => {
										if (tabelaRedux.usuarioAlteracao) {
											setOpenUsuario(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-mercosul"
									classText="button-texto-user"
									titulo="Gerar Placa Mercosul"
									cor="#FFFFFF"
									valor={values}
									onClick={() => {
										if (tabelaRedux.usuarioAlteracao) {
											setOpenMercosul(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
						</div>
					</MotionContainer>
				) : (
					<MotionContainer animationKey="CaminhaoCadastroScreen">
						<div className="content-container">
							{!props.desabilitar && (
								<div className="texto-cadastro-container">
									{props.botaoFechar !== false && (
										<div style={{ width: 29, height: 29 }} />
									)}
									<div className="texto-cadastro">
										<p className="indicador-emb">{"Dados de Caminhao / "}</p>
										{editando ? (
											<p className="indicador-emb">{"Detalhes de Caminhao"}</p>
										) : (
											<p className="indicador-emb">{"Cadastro de Caminhao"}</p>
										)}
										<HeaderCadastro texto="" />
									</div>
									{props.botaoFechar !== false && (
										<div className="close-btn">
											<CloseIcon
												onClick={() => {
													setValues({});
													setTelaCadastro(false);
													setEditando(false);
													setTabelaRedux({});
												}}
											/>
										</div>
									)}
								</div>
							)}
							<div className="flex-column">
								<div className="container-select-emb">
									<div className="rota-div-2">
										<div className="input-box-container">
											<div className="input-container">
												<p className="input-label-emb" htmlFor="descricao">
													Placa:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{
														width: "200px",
														borderColor:
															validator.placa === "false" ? "red" : "",
													}}
													onChange={handleChangePlaca}
													placeholder="AAA-1A11"
													maxLength={7}
													onBlur={(e) => {
														verificadorExistenciaCaminhao(e.target.value);
													}}
													value={values.placa}
													disabled={props.desabilitar || editando}
												/>
												{validator.placa === "false" && (
													<div className="error-input-text">
														{errorMessagePlacaValida}
													</div>
												)}
											</div>
										</div>
										<div className="coluna-emb">
											<div className="input-container">
												<p className="input-label-emb" htmlFor="descricao">
													Ano:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{
														width: "200px",
														borderColor: validator.ano === "false" ? "red" : "",
													}}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															ano: valorMask(e.target.value),
														}));
														setValidator((current) => ({
															...current,
															ano: "true",
														}));
													}}
													placeholder="2020"
													maxLength={4}
													value={values.ano}
													disabled={props.desabilitar}
												/>
												{validator.ano === "false" && (
													<div className="error-input-text">
														{errorAnoValido}
													</div>
												)}
											</div>
										</div>
										<div className="input-box-container">
											<div className="input-container">
												<p className="input-label-emb" htmlFor="descricao">
													Renavam:
												</p>
												<input
													type="text"
													placeholder="00000000000"
													maxLength={11}
													className="input-emb"
													style={{
														width: "265px",
														borderColor:
															validator.renavam === "false" ? "red" : "",
													}}
													onChange={handleChangeRenavam}
													value={values.renavam}
													disabled={props.desabilitar}
												/>
												{validator.renavam === "false" && (
													<div className="error-input-text">
														RENAVAM inválido.
													</div>
												)}
											</div>
										</div>
									</div>
									<div className="rota-div-2">
										<div className="coluna-emb">
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													Modelo:
												</p>
												<input
													type="text"
													className="input-emb"
													placeholder="FH 440"
													maxLength={24}
													style={{ width: "265px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															modelo: e.target.value.toUpperCase(),
														}));
													}}
													value={values.modelo}
													disabled={props.desabilitar}
												/>
											</div>
										</div>
										<div className="coluna-emb">
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													Marca:
												</p>
												<input
													type="text"
													className="input-emb"
													placeholder="VOLVO"
													maxLength={12}
													style={{ width: "265px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															marca: e.target.value.toUpperCase(),
														}));
													}}
													value={values.marca}
													disabled={props.desabilitar}
												/>
											</div>
										</div>
										<div className="coluna-emb">
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													Eixos:
												</p>
												<input
													type="number"
													className="input-emb"
													placeholder="Ex: 3"
													min="1"
													max="5"
													style={{
														width: "200px",
														borderColor:
															validator.numeroEixos === "false" ? "red" : "",
													}}
													onChange={(e) => {
														const valor = Math.max(
															1,
															Math.min(5, Number(e.target.value))
														);
														setValues((current) => ({
															...current,
															numeroEixos: valor,
														}));
														setValidator((current) => ({
															...current,
															numeroEixos: "true",
														}));
													}}
													value={values.numeroEixos}
													disabled={props.desabilitar}
												/>
												{validator.numeroEixos === "false" && (
													<InputError error="Número de eixos é obrigatório." />
												)}
											</div>
										</div>
									</div>
									<div className="rota-div-2">
										<div className="coluna-emb">
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													Frota:
												</p>
												<FormControl sx={{ width: 260 }}>
													<Select
														value={valuesSelect.frota}
														options={opcoesFrota}
														formatOptionLabel={labelFrota}
														styles={estiloFrota}
														placeholder=""
														menuPortalTarget={document.body}
														noOptionsMessage={() => "Não há mais opções"}
														onChange={(selectedOption) => {
															if (selectedOption) {
																setValues((current) => ({
																	...current,
																	frota: selectedOption.opcao,
																}));
																setValuesSelect((current) => ({
																	...current,
																	frota: selectedOption,
																}));
																setValidator((current) => ({
																	...current,
																	validatorFrota: "true",
																}));
															}
														}}
													/>
												</FormControl>
											</div>
										</div>
										<div className="coluna-emb">
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													KM:
												</p>
												<input
													type="text"
													className="input-emb"
													placeholder="0,00"
													style={{ width: "265px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															km: e.target.value,
														}));
													}}
													value={valorMask(values.km)}
													disabled={props.desabilitar}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
							<Separator size="md" />
						</div>
						<div className="footer-container">
							{editando ? (
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Salvar"
									cor="#0946B8"
									valor={values}
									onClick={editar}
								/>
							) : (
								<>
									{!props.desabilitar && (
										<CustomButtonV2
											classCss="custom-button-cadastrar"
											classText="button-texto-cadastrar"
											icone="iconeSave"
											titulo="Salvar"
											cor="#0946B8"
											valor={values}
											onClick={cadastrar}
										/>
									)}
								</>
							)}
							{!props.botaoVoltar && (
								<CustomButtonV2
									classCss="custom-button-cancelar"
									classText="button-texto-cancelar"
									titulo="Cancelar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setValues({});
										setTelaCadastro(false);
										setEditando(false);
										setTabelaRedux({});
									}}
								/>
							)}
						</div>
					</MotionContainer>
				)}
			</AnimatePresence>
			<div>
				<ModalConfirmacao
					titulo="Deletar"
					texto="Deseja Deletar?"
					tituloConfirmar="Confirmar"
					tituloCancelar="Cancelar"
					open={open}
					onClose={handleClose}
					onClick={deletarCaminhaoPorId}
				/>
				<ModalConfirmacao2
					titulo="Mercosul"
					texto="Deseja Converter essa Placa para o modelo Mercosul?"
					tituloConfirmar="Sim"
					tituloCancelar="Não"
					textoBotao="Gerar"
					open={openMercosul}
					onClose={handleCloseMercosul}
					onClick={transformaMercosul}
				/>
				<ModalUsuario
					titulo="Usuário"
					tituloConfirmar="OK"
					open={openUsuario}
					onClose={handleCloseUsuario}
				/>
			</div>
			<div>
				<ToastSucesso
					texto={textoSucesso}
					open={openToastSucesso}
					onClose={handleCloseToastSucesso}
				/>
				<ToastErro
					texto={textoErro}
					open={openToastErro}
					onClose={handleCloseToastErro}
				/>
			</div>
		</Layout>
	);
}

export default Caminhao;
